import React from "react";
import styled from "styled-components";
import { NavLink, } from "react-router-dom";
import { compose, getContext, lifecycle, withState } from "recompose";
import { connect } from "react-redux"
import PropTypes from "prop-types";
import R from 'ramda'
import _ from 'lodash'
import _f from 'lodash/fp'

import * as m from "../style/mixins";
import * as v from "../style/vars";
import * as consts from "src/consts";

import {
	GridCell,
	Button,
	plog,
	checkRerenders
} from "../common";

// --------------------------------------------------

const Wrapper = styled(GridCell)`
	position: fixed;
	left: 0;

	top: 0;
	bottom: 0;
	${m.bpEither("width", v.dim.panel.width)}
	background-color: white;
	
	display: flex;
	flex-direction: column;
	z-index: 1;
	${m.xs`
		left: ${p => p.open ? 0 : `-${v.dim.panel.width.xs}`}
		${p => p.open ? m.shadow(2) : ""}
		transition: 0.15s ease-out all;
	`}
	${m.bp.sm.min`
		left: 0;
		${m.shadow(2)}
	`}

`;

const Section = styled(GridCell)`
`;

const BottomSection = styled(Section)`
	margin-top: auto;
`;

const Header = styled.div`
	font-size: 1.2em;
	font-weight: bold;
	line-height: 1.5;
`;

const Link = styled(NavLink)`
	display: block;
	line-height: 1.5;
`;

const triggerDeploy = () => (
	window.confirm("Deploy changes to website?")
	? fetch("https://api.netlify.com/build_hooks/5a023dd9df99530ef9c1842e", {
		method: "POST",
	})
	.then(plog("trigger deploy"))
	.then(() => window.alert("Deploy triggered. Changes should be reflected on website in 1-2 mins."))
	: undefined
);

const enhance = compose(
	connect(R.identity),
	withState("gallerySections", "setGallerySections", []),
	// checkRerenders('Panel'),
	lifecycle({
		componentDidMount() {
			const { space, setGallerySections } = this.props
			space.getEntries({ "content_type": "gallerySection" })
				.then(entries => {
					const gallerySectionsList = _.get(entries, 'items', [])

					const gallerySections = {}
					gallerySectionsList.forEach((entry) => {
						gallerySections[_.get(entry, 'sys.id')] = _.get(entry, 'fields')
					})

					gallerySectionsList.forEach((entry) => {
						if (entry.fields.childSections) {
							entry.fields.childSections = (_.get(entry, ['fields','childSections', consts.lang]) || []).map((childSection) => {
								return gallerySections[_.get(childSection, 'sys.id')]
							})
						}
					})

					const parentGallerySectionsList = _(gallerySectionsList)
						.filter(_f.get('fields.childSections'))
						.sortBy('fields.order')
						.value()

					const gallerySectionsForPanelLinks = _(parentGallerySectionsList)
						.map(pgs => {
							return _.get(pgs, ['fields','childSections'], [])
						})
						.flatten()
						.map(x => _.mapValues(x, _f.get(consts.lang)))
						.value()

					console.log({ parentGallerySectionsList, gallerySections, gallerySectionsForPanelLinks })
				
					setGallerySections(gallerySectionsForPanelLinks)
				})
		}
	})
)

// --------------------------------------------------

const Panel = ({ panelOpen, gallerySections }) => (
	<Wrapper open = { panelOpen }>
		<Section>
			<Header>Images</Header>
			<Link to = "/editor/gallery/upload">Upload</Link>
			<Link to = "/editor/gallery">Edit</Link>
			{gallerySections.map(gallerySection => {
				const { title, tag } = gallerySection || {}
				return <Link
					key = { tag }
					to = {`/editor/gallery/tag/${tag}`}
					children = {`- ${title} (${tag})`}
				/>
			})}
		</Section>

		<Section>
			<Header>Pages</Header>
			<Link to = "/editor/page/home">Home</Link>
			<Link to = "/editor/page/about">About</Link>
			<Link to = "/editor/page/classes">Classes</Link>
			<Link to = "/editor/page/test">Test</Link>
			<Link to = "/editor/page/siteSettings">Site Settings</Link>
		</Section>

		<BottomSection>
			<Button
				onClick = { triggerDeploy }
				text = "Deploy changes"
			/>
		</BottomSection>
	</Wrapper>
);

export default enhance(Panel);


// WEBPACK FOOTER //
// ./src/components/Editor/Panel.js